export const purchaseOrderStatusOptions = {
  'concept': 'concept',
  'requested': 'aangevraagd',
  'received': 'ontvangen',
}

export type PurchaseOrderStatus = keyof typeof purchaseOrderStatusOptions;

export class PurchaseOrder {
  constructor(
    public readonly id: string,
    public readonly poNumber: string|null,
    public readonly projectId: string,
    public readonly employeeId: string,
    public readonly relationId: string,
    public readonly status: PurchaseOrderStatus,
    public readonly filePath: string|null,
    public readonly fileName: string|null,
    public readonly fileExtension: string|null,
    public readonly amount: number|null,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {
  }

  static fromJson(json: any): PurchaseOrder {
    return new PurchaseOrder(
      json['id'],
      json['po_number'],
      json['project_id'],
      json['employee_id'],
      json['relation_id'],
      json['status'] as PurchaseOrderStatus,
      json['file_path'],
      json['file_name'],
      json['file_extension'],
      json['amount'] !== null ? json['amount'] / 100 : null,
      new Date(json['created_at']),
      new Date(json['updated_at']),
    )
  }
}